import { render, staticRenderFns } from "./TabBookingDetail.vue?vue&type=template&id=e580f158&scoped=true"
import script from "./TabBookingDetail.vue?vue&type=script&lang=js"
export * from "./TabBookingDetail.vue?vue&type=script&lang=js"
import style0 from "./TabBookingDetail.vue?vue&type=style&index=0&id=e580f158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e580f158",
  null
  
)

export default component.exports